import React from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import { XTabNav } from '@/components/xqxc_ui';
import LanguagePack from '../languagePack'; //提醒设置
import ApplyReason from '../applyReason'; //申诉理由配置
import Complaint from '../complaint'; //投诉原因配置
import Riskcontrol from '../riskcontrol'; //限制配置
import AbnormalType from '../abnormalType'; //异常类型配置
import CancelReason from '../cancelReason'; //取消原因配置
import PunishReason from '../punishReason'; //惩罚原因配置
import Insuranceset from '../insuranceset'; //白鸽保险设置
import RiderInsuranceConfig from '../riderInsuranceConfig'; //骑手投保配置

class Main extends React.Component {

    state = {
        tab: [
            { id: 1, label: '提醒设置' },
            { id: 2, label: '限制配置' },
            { id: 3, label: '投诉原因配置' },
            { id: 4, label: '申诉理由配置' },
            { id: 5, label: '异常类型配置' },
            { id: 6, label: '取消原因配置' },
            { id: 7, label: '惩罚原因配置' },
            { id: 8, label: '白鸽保险设置' },
            { id: 9, label: '骑手投保配置' },
        ],
        curTabID: 1,  // 默认显示的tab
    }

    componentDidMount() {
        const { history } = this.props;
        if (history.location.state && history.location.state) {
            this.setState({ curTabID: history.location.state }); // 如果路由过来的state参数带tabID值，则渲染该tabID值下的内容
        }
    }

    // Tab导航切换操作回调
    _tabChangeHandle = (tabID) => {
        this.setState({ curTabID: tabID });
    }

    // 渲染相应Tab导航下的内容 
    _renderPage = () => {
        const { curTabID } = this.state;
        switch (curTabID) {
            case 1:
                return <LanguagePack curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 2:
                return <Riskcontrol curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 3:
                return <Complaint curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 4:
                return <ApplyReason curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 5:
                return <AbnormalType curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 6:
                return <CancelReason curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 7:
                return <PunishReason curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 8:
                return <Insuranceset curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            case 9:
                return <RiderInsuranceConfig curTabID={this.state.curTabID} history={this.props.history} updateContent={this.props.updateContent} />;
            default:
                return null;

        }
    }

    render() {
        return (
            <div className={styles.flexBoxContainer}>
                <XTabNav renderData={this.state.tab} onChange={this._tabChangeHandle} activedID={this.state.curTabID} />
                <div className={styles.line}></div>
                <div className={styles.tableContainer}>
                    {this._renderPage()}
                </div>
            </div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由history对象
    updateContent: PropTypes.func, // 跳转其它路由页面
};

export default Main;